module.exports = __webpack_public_path__ + "static/media/time_inactive.19d86995.svg";